import React, { useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import block from 'bem-cn';

import './NotificationDetails.scss';

const b = block('notification-details-desktop');

const NotificationDetails = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { notifications } = useSelector(state => state.creativeFunctionality.detailsData);

  return (
    <div className={b()}>
      <div className={b('header')}>{locale.wasNotifications}:</div>
      <div className={b('text')}>{notifications}</div>
    </div>
  );
};

export default NotificationDetails;
